import "./App.css";
import HierarchicalTable from "./components/HierarchicalTable";
import { initialData } from "./data/initialData";

function App() {
  return (
    <div className="App">
      <HierarchicalTable data={initialData} />
    </div>
  );
}

export default App;
